// extracted by mini-css-extract-plugin
export default {"restart_button":"RestartButton_restart_button__ERwOB"};